import { render, staticRenderFns } from "./MatchOptionsUpload.vue?vue&type=template&id=1a367096&scoped=true&"
import script from "./MatchOptionsUpload.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a367096",
  null
  
)

export default component.exports